import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import * as firebase from "firebase";
import EditMatterDialog from "./components/Matter/Edit/EditMatterDialog.vue";
import AddInitialDocsDialog from "./components/Matter/AddInitialDocsDialog.vue";
import InitialDocs from "./components/Matter/InitialDocs.vue";
import Plaintiffs from "./components/Matter/Plaintiffs/Plaintiffs.vue";
import Defendants from "./components/Matter/Defendants/Defendants.vue";
import ViewParty from "./components/Matter/ViewParty.vue";
import ViewPlaintiff from "./components/Matter/Plaintiffs/ViewPlaintiff.vue";
import ViewDefendant from "./components/Matter/Defendants/ViewDefendant.vue";
import ViewMatterNotes from "./components/Matter/ViewMatterNotes.vue";
import AddMatterNotes from "./components/Matter/AddMatterNotes.vue";
import AddPlaintiffDialog from "./components/Matter/Plaintiffs/AddPlaintiffDialog.vue";
import EditPlaintiffDialog from "./components/Matter/Plaintiffs/Edit/EditPlaintiffDialog.vue";
import AddDefendantDialog from "./components/Matter/Defendants/AddDefendantDialog.vue";
import EditDefendantDialog from "./components/Matter/Defendants/Edit/EditDefendantDialog.vue";
import AddDamageDialog from "./components/Matter/Plaintiffs/AddDamageDialog.vue";
import SendClientFormDialog from "./components/Matter/Plaintiffs/SendClientFormDialog.vue";
import CreateDocTest from "./components/CreateDocTest.vue";
import FormResponses from "./components/Matter/Plaintiffs/FormResponses.vue";
import CreatePlaintiffDoc from "./components/Matter/Plaintiffs/CreatePlaintiffDoc.vue";
import CreateMatterDoc from "./components/Matter/Plaintiffs/CreateMatterDoc.vue";
import SelectedDocForm from "./components/Matter/Plaintiffs/SelectedDocForm.vue";
import AddAttorneyDialog from "./components/Matter/AddAttorneyDialog.vue";
import AddFirmDialog from "./components/Matter/AddFirmDialog.vue";
import ViewMatterActivities from "./components/Matter/ViewMatterActivities.vue";
import ContentsStepper from "./components/Matter/ContentsStepper.vue";
import ContentsStepper2 from "./components/Matter/ContentsStepper2.vue";
import ContentsStepper3 from "./components/Matter/ContentsStepper3.vue";
import DocUploader from "./components/DocUploader.vue";
import AdminDocUploader from "./components/AdminDocUploader.vue";
import VideoConfDialog from "./components/VideoConf.vue";
import CodeSelector from "./components/CodeSelector.vue";
import UploadUserList from "./components/UploadUserList.vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import BootstrapVue from "bootstrap-vue";
import VueSilentbox from "vue-silentbox";
import { VueMasonryPlugin } from "vue-masonry";
import WOW from "wow.js/dist/wow.js";
import VueMeta from "vue-meta";
import ThirdPartySignUpDialog from "./components/ThirdPartySignUpDialog.vue";

Vue.use(VueMasonryPlugin);
Vue.use(VueSilentbox);
Vue.use(BootstrapVue);
Vue.use(VueAwesomeSwiper);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

import "bootstrap/dist/css/bootstrap.css";
import "../src/assets/css/fontawesome-all.min.css";
import "swiper/dist/css/swiper.css";
import "animate.css/animate.min.css";
import "../src/assets/scss/style.scss";
import "slick-carousel/slick/slick.css";

// import Alert from "./components/Shared/Alert.vue";

Vue.config.productionTip = false;

Vue.component("app-edit-matter-dialog", EditMatterDialog);
Vue.component("app-add-initial-docs-dialog", AddInitialDocsDialog);
Vue.component("app-view-initial-docs", InitialDocs);
Vue.component("app-view-plaintiffs", Plaintiffs);
Vue.component("app-view-defendants", Defendants);
Vue.component("app-view-party", ViewParty);
Vue.component("app-view-plaintiff", ViewPlaintiff);
Vue.component("app-view-defendant", ViewDefendant);
Vue.component("app-add-plaintiff-dialog", AddPlaintiffDialog);
Vue.component("app-edit-plaintiff-dialog", EditPlaintiffDialog);
Vue.component("app-add-defendant-dialog", AddDefendantDialog);
Vue.component("app-edit-defendant-dialog", EditDefendantDialog);
Vue.component("app-add-damage-dialog", AddDamageDialog);
Vue.component("send-client-form-dialog", SendClientFormDialog);
Vue.component("app-create-doc-test", CreateDocTest);
Vue.component("app-view-form-resps", FormResponses);
Vue.component("app-create-plaintiff-doc", CreatePlaintiffDoc);
Vue.component("app-create-matter-doc", CreateMatterDoc);
Vue.component("app-add-attorney-dialog", AddAttorneyDialog);
Vue.component("app-add-firm-dialog", AddFirmDialog);
Vue.component("app-selected-doc-form", SelectedDocForm);
Vue.component("app-doc-uploader-dialog", DocUploader);
Vue.component("app-admin-doc-uploader-dialog", AdminDocUploader);
Vue.component("app-video-conf-dialog", VideoConfDialog);
Vue.component("app-view-matter-notes", ViewMatterNotes);
Vue.component("app-add-matter-notes", AddMatterNotes);
Vue.component("app-view-matter-activities", ViewMatterActivities);
Vue.component("app-code-selector", CodeSelector);
Vue.component("contents-stepper", ContentsStepper);
Vue.component("contents-stepper-2", ContentsStepper2);
Vue.component("contents-stepper-3", ContentsStepper3);
Vue.component("upload-user-list", UploadUserList);
Vue.component("app-third-party-sign-up-dialog", ThirdPartySignUpDialog);

// Vue.component("app-alert", Alert);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    firebase.initializeApp({
      apiKey: "AIzaSyCaRCVn1ASQCbAoU0yhMRxcULjCcb20bpo",
      authDomain: "taplaw.firebaseapp.com",
      databaseURL: "https://taplaw.firebaseio.com",
      projectId: "taplaw",
      storageBucket: "taplaw.appspot.com",
      messagingSenderId: "701278965884",
      appId: "1:701278965884:web:19debed3aad7ea3d4339f9",
      measurementId: "G-M141HWNJ8F"
    });
    firebase.auth().onAuthStateChanged(user => {
      this.$store.dispatch("clearRole", null);

      console.log("authstatechanged from main.js", user);
      console.log("from authStateChange:", user.email);
      user.getIdTokenResult().then(idTokenResult => {
        console.log("from main - idTokenResults", idTokenResult);
        // let role = idTokenResult.claims.admin;
        if (idTokenResult.claims.admin) {
          let role = "admin";
          console.log(role);
          this.$store.dispatch("setRole", role);
          // this.$store.dispatch("autoLogin", user.email);
          // this.$store.dispatch("getFirm", user.firmSlug);
          this.$store.dispatch("autoLoginAdmin", user.email);
        }
        if (idTokenResult.claims.client) {
          let role = "client";
          console.log(role);
          console.log(this.$route.params);
          this.$store.dispatch("setRole", role);
          console.log("from authStateChange:", user.email);
          let payload;
          if (this.$route.params.client) {
            payload = {
              matter: this.$route.params.matter,
              firm: this.$route.params.firm,
              client: this.$route.params.client,
              email: user.email
            };
            this.$store.dispatch("autoLoginClient", payload);
          } else if (this.$route.params.id) {
            payload = {
              matter: this.$route.params.matter,
              firm: this.$route.params.firm,
              client: this.$route.params.id,
              email: user.email
            };
            this.$store.dispatch("autoLoginClient", payload);
          } else if (this.$route.params.location) {
            let payload = {
              matter: this.$route.params.location,
              user: user
            };
            this.$store.dispatch("autoLoginFireClient", payload);
          }
          // this.$store.dispatch("autoLoginClient", payload);
        }
        if (idTokenResult.signInProvider === "anonymous") {
          this.$store.dispatch("setAnonymousUser");
        }
      });
      // this.$store.dispatch("getFirm", user.firmSlug);
      // this.$store.dispatch("autoLogin", user.email);

      // let loggedinUser = this.$store.getters.user;
      // console.log("loggedinUser", loggedinUser);
      // this.$store.dispatch("getFirm", user.firmSlug);
      // this.$store.dispatch("getMatters", user.firmSlug);

      //experimental
      // firebase
      //   .auth()
      //   .currentUser.getIdTokenResult()
      //   .then(idTokenResult => {
      //     // Confirm the user is an Admin.
      //     if (idTokenResult.claims.admin) {
      //       // Show admin UI.
      //       console.log("user is admin");
      //       // this.role = "admin";
      //     } else if (idTokenResult.claims.client) {
      //       // Show regular user UI.
      //       console.log("user is client");
      //       // this.role = "client";
      //     } else {
      //       console.log("user is neither admin nor client");
      //     }
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    });
    // this.$store.dispatch("loadMatters");
    // firebase
    //   .auth()
    //   .currentUser.getIdTokenResult()
    //   .then(idTokenResult => {
    //     // Confirm the user is an Admin.
    //     if (idTokenResult.claims.admin) {
    //       // Show admin UI.
    //       console.log("user is admin");
    //       // this.role = "admin";
    //     } else if (idTokenResult.claims.client) {
    //       // Show regular user UI.
    //       console.log("user is client");
    //       // this.role = "client";
    //     } else {
    //       console.log("user is neither admin nor client");
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  },
  mounted() {
    new WOW().init();
  }
}).$mount("#app");
